import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    reports: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        page: null,
        pages: null,
        rowsPerPage: 25,
    },
    reportsNotAccepted: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        page: null,
        pages: null,
        rowsPerPage: 25,
    },
    reportsActive: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        page: null,
        pages: null,
        rowsPerPage: 25,
    },
    machines: {
        isLoading: false,
        isLoaded: false,
        data: null,
    },
    subjects: {
        isLoading: false,
        isLoaded: false,
        data: null,
    },
    report: {
        isLoading: false,
        isLoaded: false,
        data: null,
    },
    works: {
        isLoaded: false,
        isLoading: false,
        data: []
    },
    statusText: "",
};

export default createReducer(initialState,{
    [C.GET_REPORTS_REQUEST]: (state) => ({
        ...state,
        reports: {
            ...state.reports,
            isLoading: true
        }
    }),
    [C.GET_REPORTS_FAILURE]: (state) => ({
        ...state,
        reports: {
            ...state.reports,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка заявок."
    }),
    [C.GET_REPORTS_SUCCESS]: (state, payload) => ({
        ...state,
        reports: {
            ...state.reports,
            isLoading: false,
            isLoaded: true,
            data: payload.reports,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    }),
    [C.GET_REPORTS_ACTIVE_REQUEST]: (state) => ({
        ...state,
        reportsActive: {
            ...state.reportsActive,
            isLoading: true
        }
    }),
    [C.GET_REPORTS_ACTIVE_FAILURE]: (state) => ({
        ...state,
        reportsActive: {
            ...state.reportsActive,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка активных заявок."
    }),
    [C.GET_REPORTS_ACTIVE_SUCCESS]: (state, payload) => ({
        ...state,
        reportsActive: {
            ...state.reportsActive,
            isLoading: false,
            isLoaded: true,
            data: payload.reports,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    }),
    [C.GET_REPORTS_NOT_ACCEPTED_REQUEST]: (state) => ({
        ...state,
        reportsNotAccepted: {
            ...state.reportsNotAccepted,
            isLoading: true
        }
    }),
    [C.GET_REPORTS_NOT_ACCEPTED_FAILURE]: (state) => ({
        ...state,
        reportsNotAccepted: {
            ...state.reportsNotAccepted,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка непринятых заявок."
    }),
    [C.GET_REPORTS_NOT_ACCEPTED_SUCCESS]: (state, payload) => ({
        ...state,
        reportsNotAccepted: {
            ...state.reportsNotAccepted,
            isLoading: false,
            isLoaded: true,
            data: payload.reports,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    }),
    [C.GET_REPORTS_MACHINES_REQUEST]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: true,
        }
    }),
    [C.GET_REPORTS_MACHINES_FAILURE]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка аппарата."
    }),
    [C.GET_REPORTS_MACHINES_SUCCESS]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: true,
            data: payload,
        }
    }),
    [C.GET_REPORTS_SUBJECTS_REQUEST]: (state) => ({
        ...state,
        subjects: {
            ...state.subjects,
            isLoading: true,
        }
    }),
    [C.GET_REPORTS_SUBJECTS_FAILURE]: (state) => ({
        ...state,
        subjects: {
            ...state.subjects,
            isLoaded: false,
            isLoading: false
        },
        statusText: "Ошибка загрузки списка тем заявок."
    }),
    [C.GET_REPORTS_SUBJECTS_SUCCESS]: (state, payload) => ({
        ...state,
        subjects: {
            ...state.subjects,
            isLoading: false,
            isLoaded: true,
            data: payload
        }
    }),
    [C.GET_REPORT_REQUEST]: (state) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: true,
        }
    }),
    [C.GET_REPORT_FAILURE]: (state) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки заявки."
    }),
    [C.GET_REPORT_SUCCESS]: (state, payload) => ({
        ...state,
        report: {
            ...state.report,
            isLoaded: true,
            isLoading: false,
            data: payload,
        }
    }),
    [C.GET_REPORT_NEXT_SUCCESS]: (state, payload) => ({
        ...state,
        report: {
            ...state.report,
            isLoaded: true,
            isLoading: false,
            data: payload
        }
    }),
    [C.GET_REPORT_NEXT_FAILURE]: (state) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: false
        },
        statusText: "Ошибка обновления статуса заявки."
    }),
    [C.EDIT_REPORT_SUCCESS]: (state, payload) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: false,
            isLoaded: true,
            data: payload,
        }
    }),
    [C.EDIT_REPORT_FAILURE]: (state) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: false
        },
        statusText: "Ошибка изменения заявки."
    }),
    [C.DELETE_REPORT_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка удаления заявки."
    }),
    [C.DELETE_REPORT_SUCCESS]: (state) => ({
        ...state,
        report: {
            ...state.report,
            isLoading: false,
            isLoaded: false,
            data: null
        },
    }),
    [C.GET_REPORTS_WORKS_REQUEST]: (state) => ({
        ...state,
        works: {
            ...state.works,
            isLoading: true
        }
    }),
    [C.GET_REPORTS_WORKS_FAILURE]: (state) => ({
        ...state,
        works: {
            ...state.works,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки списка работ"
    }),
    [C.GET_REPORTS_WORKS_SUCCESS]: (state, payload) => ({
        ...state,
        works: {
            ...state.works,
            isLoaded: true,
            isLoading: false,
            data: payload,
        }
    })
})


// WEBPACK FOOTER //
// ./src/reducers/reports.js